import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

const ACTION_NAME = 'NAVIGATE';
const navigationAction = (url) => ({
  type: ACTION_NAME,
  payload: url,
});

const navigationMiddleware = (story) => (next) => (action) => {
  if (action.type === ACTION_NAME) {
    history.push(action.payload);
  }

  return next(action);
};

export { navigationMiddleware, navigationAction, history };
